module.exports = __webpack_public_path__ + "static/img/6-6.0492070.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/selection/pc/components/past-review/6-6.png
// module id = V7D4
// module chunks = 25